import { customAxiosInstanceMutator } from './custom-axios-instance';
import type { LoanApplicationComment } from './schemas/loanServiceSchemas/loanApplicationComment';
import type { LoanApplicationCommentPage } from './schemas/loanServiceSchemas/loanApplicationCommentPage';

/**
 * Add a comment to a loan application
 * @summary Add comment to loan application
 */
export const addComment = (
  loanApplicationId: string,
  comment: string,
  createdBy?: string,
  signal?: AbortSignal
) => {
  
  return customAxiosInstanceMutator<LoanApplicationComment>(
    {url: `/loan/api/v1/loan-applications/${loanApplicationId}/comments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: { comment, ...(createdBy ? { createdBy } : {}) }, signal
    },
    );
  }
  
/**
 * Retrieve comments for a loan application
 * @summary Get loan application comments
 */
export const getComments = (
  loanApplicationId: string,
  params?: {
    stage?: string;
    page?: number;
    size?: number;
  },
  signal?: AbortSignal
) => {
  
  return customAxiosInstanceMutator<LoanApplicationCommentPage>(
    {url: `/loan/api/v1/loan-applications/${loanApplicationId}/comments`, method: 'GET',
      params, signal
    },
    );
  }

/**
 * Types for comment service
 */
export type AddCommentMutationResult = Awaited<ReturnType<typeof addComment>>
export type AddCommentMutationError = Error

export type GetCommentsQueryResult = Awaited<ReturnType<typeof getComments>>
export type GetCommentsQueryError = Error